import { useContext } from "react";
import { DContext } from "../../context/DataContext";

export default function CaseStudyHero({ images, subtitle, title, services }) {
    const { setOpenForm } = useContext(DContext)

    return (
        <section className="relative w-full h-[600px] sm:h-[350px] md:h-[500px] lg:h-[750px] overflow-hidden">

            {/* Background Image */}
            <img
                src={images}
                alt="Case Study"
                className="absolute inset-0 w-full h-full object-cover"
            />

            {/* Glass Card */}
            <div className="absolute inset-0 flex items-end justify-center px-4 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4 lg:py-6">

                <div className="bg-white/80 backdrop-blur-md rounded-lg sm:rounded-2xl md:rounded-3xl p-6 sm:p-5 md:p-8 lg:p-10 sm:mx-auto md:max-w-7xl shadow-lg w-full">

                    {/* Title */}
                    <h1 className="text-base sm:text-xl md:text-2xl lg:text-4xl font-bold text-gray-900  sm:leading-snug">
                        {title}
                    </h1>

                    {/* Subtitle */}
                    <p className="mt-2 sm:mt-3 text-gray-700 text-xs sm:text-sm md:text-base lg:text-lg">
                        {subtitle}
                    </p>

                    {/* Button */}
                    <button
                        onClick={() => setOpenForm(true)}
                        className="mt-3 sm:mt-4 md:mt-5 lg:mt-6 h-10 bg-secondary-500 text-white px-3 sm:px-4 md:px-5 py-1.5 sm:py-2 md:py-2.5 rounded-lg sm:rounded-xl text-sm sm:text-sm md:text-base font-medium hover:bg-secondary-600 transition-colors duration-300">
                        Request Demo
                    </button>

                    {/* Services */}
                    {/* <div className="mt-4 sm:mt-5 md:mt-6 lg:mt-8">
                        <p className="text-gray-600 mb-2 sm:mb-3 font-medium text-xs sm:text-sm md:text-base">
                            Services Provided:
                        </p>

                        <div className="flex flex-wrap gap-2 sm:gap-2.5 md:gap-3">
                            {services.map((service, index) => (
                                <span
                                    key={index}
                                    className="border border-blue-400 text-blue-500 px-2.5 sm:px-3 md:px-4 py-0.5 sm:py-1 md:py-1.5 rounded-full text-xs sm:text-xs md:text-sm whitespace-nowrap"
                                >
                                    {service}
                                </span>
                            ))}
                        </div>
                    </div> */}

                </div>

            </div>
        </section>
    );
}
